import { createApi } from '@reduxjs/toolkit/query/react';
import { btBaseQuery } from 'src/Common/common';

// Define a service using a base URL and expected endpoints
export const emmdesignationApi = createApi({
  reducerPath: 'emmdesignationApi',
  baseQuery: btBaseQuery,
  tagTypes: ['Designation'],

  endpoints: (builder) => ({
    getDesignations: builder.query<em_mdesignation[], string>({
      query: (cid) => `emdesignation/${cid}`,
      providesTags: ['Designation']
    }),
    getDesignation: builder.query<em_mdesignation, string>({
      query: (id) => `emdesignation/byid/${id}`
    }),
    insertDesignation: builder.mutation({
      query: (emdesignation) => ({
        url: `emdesignation/`,
        method: 'POST',
        body: emdesignation
      }),
      invalidatesTags: ['Designation']
    }),
    updateDesignation: builder.mutation({
      query: (emdesignation) => ({
        url: `emdesignation/`,
        method: 'PUT',
        body: emdesignation
      }),
      invalidatesTags: ['Designation']
    }),
    deleteDesignation: builder.mutation({
      query: (emdesignation) => ({
        url: `emdesignation/${emdesignation.ds_id}`,
        method: 'DELETE',
        body: emdesignation
      }),
      invalidatesTags: ['Designation']
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetDesignationsQuery,
  useGetDesignationQuery,
  useInsertDesignationMutation,
  useUpdateDesignationMutation,
  useDeleteDesignationMutation
} = emmdesignationApi;
